/* istanbul ignore file */
export * from './plan-documents.component';
export * from './plan-documents.module';
